import { queryOptions } from '@tanstack/react-query';

import { ONE_HOUR } from '@/constants/time';
import { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

export type GetContentLibraryItemsV2Response =
  paths['/v2/content-library-items']['get']['responses'][200]['content']['application/json']['data'];

export async function getContentLibraryItemsV2(): Promise<GetContentLibraryItemsV2Response | null> {
  const { data } = await fetchClient.GET('/v2/content-library-items', {});

  return data?.data ?? null;
}

export function getContentLibraryItemsV2QueryOptions() {
  return queryOptions({
    queryKey: ['contentLibraryItemsV2'],
    queryFn: () => getContentLibraryItemsV2(),
    staleTime: ONE_HOUR,
    gcTime: ONE_HOUR,
  });
}
